import React, { useState } from "react";
import styled from "styled-components";
import Button from "components/bootstrap/Button";
import Modal from "components/bootstrap/Modal";
import Well from "components/bootstrap/Well";
import Icon from "components/common/Icon";
import DocumentTitle from "components/common/DocumentTitle";
import { qualifyUrl } from "util/URLUtils";
import LoginChrome from "components/login/LoginChrome";
import useProductName from "brand-customization/useProductName";
import DocsHelper from "util/DocsHelper";
const StyledIcon = styled(Icon)`
  margin-left: 6px;
`;
const ServerUnavailablePage = ({ server = void 0 }) => {
  const productName = useProductName();
  const [showDetails, setShowDetails] = useState(false);
  const _toggleDetails = () => setShowDetails(!showDetails);
  const _formatErrorMessage = () => {
    if (!showDetails) {
      return null;
    }
    const noInformationMessage = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("p", null, "There is no information available."));
    if (!(server == null ? void 0 : server.error)) {
      return noInformationMessage;
    }
    const { error } = server;
    const errorDetails = [];
    if (error.message) {
      errorDetails.push(/* @__PURE__ */ React.createElement("dt", { key: "error-title" }, "Error message"), /* @__PURE__ */ React.createElement("dd", { key: "error-desc" }, error.message));
    }
    if (error.originalError) {
      const { originalError } = error;
      errorDetails.push(
        /* @__PURE__ */ React.createElement("dt", { key: "status-original-request-title" }, "Original Request"),
        /* @__PURE__ */ React.createElement("dd", { key: "status-original-request-content" }, String(originalError.method), " ", String(originalError.url))
      );
      errorDetails.push(
        /* @__PURE__ */ React.createElement("dt", { key: "status-code-title" }, "Status code"),
        /* @__PURE__ */ React.createElement("dd", { key: "status-code-desc" }, String(originalError.status))
      );
      if (typeof originalError.toString === "function") {
        errorDetails.push(
          /* @__PURE__ */ React.createElement("dt", { key: "full-error-title" }, "Full error message"),
          /* @__PURE__ */ React.createElement("dd", { key: "full-error-desc" }, originalError.toString())
        );
      }
    }
    if (errorDetails.length === 0) {
      return noInformationMessage;
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("hr", { style: { marginTop: 10, marginBottom: 10 } }), /* @__PURE__ */ React.createElement("p", null, "This is the last response we received from the server:"), /* @__PURE__ */ React.createElement(Well, { bsSize: "small", style: { whiteSpace: "pre-line" } }, /* @__PURE__ */ React.createElement("dl", { style: { marginBottom: 0 } }, errorDetails)));
  };
  const modalTitle = "Server currently unavailable";
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Server unavailable" }, /* @__PURE__ */ React.createElement(LoginChrome, null, /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: () => {
  } }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), " ", modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, "We are experiencing problems connecting to the ", productName, " server running on ", /* @__PURE__ */ React.createElement("i", null, qualifyUrl("")), ". Please verify that the server is healthy and working correctly."), /* @__PURE__ */ React.createElement("p", null, "You will be automatically redirected to the previous page once we can connect to the server."), /* @__PURE__ */ React.createElement("p", null, "Do you need a hand?", " ", /* @__PURE__ */ React.createElement("a", { href: DocsHelper.PAGES.SERVER_UNAVAILABLE, rel: "noopener noreferrer", target: "_blank" }, "We can help you"), "."), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", tabIndex: 0, onClick: _toggleDetails, bsSize: "sm" }, showDetails ? "Less details" : "More details", /* @__PURE__ */ React.createElement(StyledIcon, { name: showDetails ? "keyboard_arrow_up" : "keyboard_arrow_down" })), _formatErrorMessage()))))));
};
export default ServerUnavailablePage;
